export const TRIPMASTER_ACCESS_STORAGE_KEY = "tripmaster_access_gate_v1";
export const TRIPMASTER_ACCESS_STORAGE_VALUE = "ok";
export const TRIPMASTER_ACCESS_PASSWORD = "15061985";
export const TRIPMASTER_ACCESS_UNLOCKED_EVENT = "tripmaster-access-unlocked";

export function readTripMasterAccessUnlocked(storage) {
  try {
    const store = storage || (typeof window !== "undefined" ? window.localStorage : null);
    return store?.getItem(TRIPMASTER_ACCESS_STORAGE_KEY) === TRIPMASTER_ACCESS_STORAGE_VALUE;
  } catch {
    return false;
  }
}

export function persistTripMasterAccessUnlocked(storage) {
  const store = storage || (typeof window !== "undefined" ? window.localStorage : null);
  if (!store) return false;
  try {
    store.setItem(TRIPMASTER_ACCESS_STORAGE_KEY, TRIPMASTER_ACCESS_STORAGE_VALUE);
    return true;
  } catch {
    return false;
  }
}

export function evaluateTripMasterAccessPassword(input) {
  return String(input ?? "").trim() === TRIPMASTER_ACCESS_PASSWORD;
}

/** Construction gate retired — TripMaster is public. */
export function shouldBlockTripMasterAccess({ hostname, storage, env } = {}) {
  void hostname;
  void storage;
  void env;
  return false;
}

export function notifyTripMasterAccessUnlocked() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(TRIPMASTER_ACCESS_UNLOCKED_EVENT));
}
